<template>
  <div class="healthInsurance-card">
    <header v-if="cardDetails.insuranceName">
      <h3 class="healthInsurance-card__insurance">
        {{ cardDetails.insuranceName }}
      </h3>

      <hr class="healthInsurance-card__divider" />
    </header>

    <section v-if="cardDetails.clientName" class="healthInsurance-card__section">
      <h4 class="healthInsurance-card__pacient-name">
        {{ cardDetails.clientName }}
      </h4>
    </section>

    <section
      v-for="(section, i) in this.cardSections"
      :key="i"
      class="healthInsurance-card__section flex flex-justify-content--between"
    >
      <section
        v-for="(item, x) in section.items"
        :key="x"
        class="healthInsurance-card__section__item"
      >
        <span class="healthInsurance-card__section__item__title">
          {{ item.question.content }}
        </span>

        <span class="healthInsurance-card__section__item__content">
          {{ item.answer.content }}
        </span>
      </section>
    </section>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { cardDetails, cardFields, insuranceDataIssues, dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'HealthInsuranceCard',

  mixins: [cardDetails, cardFields, insuranceDataIssues, dataLayersMixin],

  async mounted() {
    try {
      this.enableLoader(true);
      await this.getInsuranceVariables();
    } catch (error) {
      console.log(error);
    } finally {
      this.enableLoader(false);
    }

    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Confirme os dados da sua carteirinha',
    });
  },

  computed: {
    /**
     * @function cardSections
     * @returns {array} Sections containing status and inner items
     * @see cardFooterSection
     * @see cardDetails.mixin/dynamicSections
     */
    cardSections() {
      const uniqueDynamicSections = this.dynamicSections.reduce((acc, item) => {
        if (acc.find((t) => JSON.stringify(t) === JSON.stringify(item))) {
          return acc;
        }
        acc.push(item);
        return acc;
      }, []);

      const allSections = this.cardFooterSection.active
        ? uniqueDynamicSections.concat(this.cardFooterSection)
        : uniqueDynamicSections;

      return [...new Set(allSections)];
    },
    cardFooterSection() {
      const cardNumberStatus = !!this.cardDetails?.cardNumber;
      const cardExpirationDateStatus = !!this.cardDetails?.cardExpirationDate;

      const items = [
        {
          active: cardNumberStatus,
          question: { content: 'Número da Carteirinha' },
          answer: { content: this.cardDetails?.cardNumber },
        },
        {
          active: cardExpirationDateStatus,
          question: { content: 'Validade' },
          answer: { content: this.cardDetails?.cardExpirationDate },
        },
      ];

      return {
        active: cardNumberStatus || cardExpirationDateStatus,
        items: items.filter((item) => item.active),
      };
    },
  },

  methods: {
    ...mapMutations(['enableLoader']),
  },
};
</script>

<style lang="scss" scoped>
.healthInsurance-card {
  border-radius: 8px;
  border: 1px solid #0000001a;
  box-shadow: 0 6px 30px 0 #00000033;
  max-width: 380px;
  padding: 13px 16px 5px 16px;
  text-align: left;

  &__insurance {
    font-size: var(--font-size-3);
    font-weight: var(--font-weight-black);
    margin-bottom: 12px;
  }

  &__divider {
    border-bottom: 1px solid var(--color-grey-4);
    margin-bottom: 12px;
  }

  &__pacient-name {
    font-size: var(--font-size-3);
    font-weight: var(--font-weight-black);
    text-transform: uppercase;
  }

  &__section {
    margin-bottom: 12px;

    &__item {
      display: inline-block;
      margin-right: 12px;

      &__title {
        color: var(--color-grey-11);
        display: block;
        font-size: var(--font-size-2);
        margin-bottom: 2px;
        letter-spacing: 0.0025em;
      }

      &__content {
        color: #18191b;
        display: block;
        font-size: var(--font-size-2);
        font-weight: var(--font-weight-medium);
        letter-spacing: 0.005em;
      }
    }
  }
}
</style>
